<template>
  <div class="user_list" v-loading="loading">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="userName" suffix-icon="el-icon-search" placeholder="请输入用户姓名" @change="onSearch" clearable></el-input>
      <el-input class="s_input" v-model="userPhone" suffix-icon="el-icon-search" placeholder="请输入手机号码" @change="onSearch" clearable></el-input>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="userName" label="用户姓名"></el-table-column>
        <el-table-column show-overflow-tooltip prop="userPhone" label="手机号码"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="" label="紧急联系人"></el-table-column> -->
        <!-- <el-table-column show-overflow-tooltip prop="" label="紧急联系电话"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="createdTime" label="注册时间"></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="handleShow(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      userName: "",
      userPhone: "",
      sourceType: "",
      tableData: [],
      dialogVisible: false,
      fileList: [],
      submitLoding: false,
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      headers: { token: this.$store.state.token },

      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 客情列表
    getList() {
      this.loading = true
      this.$axios
        .get(this.$api.customerFollowselectUserList, {
          params: {
            userName: this.userName,
            userPhone: this.userPhone,
            // sourceType: this.sourceType, // 来源:1预约:2导入
            page: this.currentPage, // 页码数
            pageSize: this.pageSize, // 每页数量
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    handleShow(e) {
      let { userId, userName, userPhone, createdTime } = e
      this.$router.push({ name: "customerUserDetail", query: { userId } })
    },
    onCancel() {
      this.fileList = []
      this.$refs.upload.clearFiles()
      this.dialogVisible = false
    },
    onSubmit() {
      if (this.fileList.length == 0) {
        this.$message.error("请选择文件")
      } else {
        let params = new FormData()
        params.append("file", this.fileList[0].raw)
        this.submitLoding = false
        this.$axios
          .post(this.$api.importCustomerUser, params)
          .then(res => {
            this.submitLoding = false
            this.$message.success("导入成功")
            this.dialogVisible = false
            this.getList()
          })
          .catch(err => {
            this.submitLoding = false
            this.$message.error(err.desc)
          })
      }
    },
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
  },
}
</script>

<style scoped lang="scss"></style>
